import React from 'react';
import { NavLink } from 'react-router-dom';
import { person } from '../data/site';

export default function TopNav() {
  return (
    <header className="personal-header">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <nav className="personal-nav" aria-label="Primary navigation">
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/ideas">Ideas</NavLink>
        <NavLink to="/writing">Writing</NavLink>
      </nav>
      <span className="header-location">{person.location}</span>
    </header>
  );
}
